// The number of pixels that is the cutoff for if a swipe action should fire or not
export const swipeCutoff: number = 100;
export const tapCutoff: number = 5;
